import { resolvePublicAssetUrl } from './resolvePublicAssetUrl.js';

/**
 * Faction orb styling for Explore Unknown map mission waypoints.
 * Icon transparency matches Strategy.js (`mix-blend-mode: screen` on faction PNGs).
 */

const factionColors = {
  'Remnants of Humanity': '#556B2F',
  'Exolot Dominion': '#4B0082',
  'League of Shadows': '#1A1A1A',
  "Ra's Children": '#F4A460',
  Asrah: '#8B0000',
  'The Sentients': '#ADD8E6',
  Combined: '#FFA500',
};

const factionIconByName = {
  'Remnants of Humanity': 'remnants.png',
  'Exolot Dominion': 'exolot.png',
  'League of Shadows': 'league.png',
  "Ra's Children": 'ra.png',
  Asrah: 'asrah.png',
  'The Conspiracy': 'conspiracy.png',
  'The Corrupted Core': 'core.png',
  'The Covenant': 'covenant.png',
  'The Divine Syndicate': 'syndicate.png',
  'The Forsaken Pact': 'forsaken.png',
  'The Hollow': 'hollow.png',
  'The Iron Alliance': 'alliance.png',
  'The Last Crusade': 'crusade.png',
  'The Shadow Consortium': 'consortium.png',
  'The Silent Accord': 'silent.png',
  'The Sentients': 'sentients.png',
};

export function getExploreUnknownMapFactionOrbBackground(factionName) {
  if (!factionName || factionName === 'Unknown') {
    throw new Error('getExploreUnknownMapFactionOrbBackground: factionName is required');
  }

  if (factionName === 'The Conspiracy') {
    return 'linear-gradient(to right, #8B0000 50%, #1A1A1A 50%)';
  }
  if (factionName === 'The Corrupted Core') {
    return 'linear-gradient(to right, #4B0082 50%, #8B0000 50%)';
  }
  if (factionName === 'The Covenant') {
    return 'linear-gradient(to right, #F4A460 50%, #1A1A1A 50%)';
  }
  if (factionName === 'The Divine Syndicate') {
    return 'linear-gradient(to right, #F4A460 50%, #4B0082 50%)';
  }
  if (factionName === 'The Forsaken Pact') {
    return 'linear-gradient(to right, #556B2F 50%, #8B0000 50%)';
  }
  if (factionName === 'The Hollow') {
    return 'linear-gradient(to right, #F4A460 50%, #8B0000 50%)';
  }
  if (factionName === 'The Iron Alliance') {
    return 'linear-gradient(to right, #556B2F 50%, #4B0082 50%)';
  }
  if (factionName === 'The Last Crusade') {
    return 'linear-gradient(to right, #F4A460 50%, #556B2F 50%)';
  }
  if (factionName === 'The Shadow Consortium') {
    return 'linear-gradient(to right, #1A1A1A 50%, #4B0082 50%)';
  }
  if (factionName === 'The Silent Accord') {
    return 'linear-gradient(to right, #556B2F 50%, #1A1A1A 50%)';
  }

  const solid = factionColors[factionName];
  if (!solid) {
    throw new Error(
      `getExploreUnknownMapFactionOrbBackground: faction color mapping missing for ${factionName}`
    );
  }
  return solid;
}

export function getExploreUnknownMapFactionIconPath(factionName) {
  if (!factionName || factionName === 'Unknown') {
    return null;
  }

  const iconFile = factionIconByName[factionName];
  if (!iconFile) {
    throw new Error(
      `getExploreUnknownMapFactionIconPath: faction icon mapping missing for ${factionName}`
    );
  }

  return resolvePublicAssetUrl(`/factions/${iconFile}`);
}
